import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ct } from "../../../../constant-Utils";

// props detail
  // type (String) => current active type
  // types (object) => types contains type of each button e.g monthly or yearly
  // buttonName1 (String) = In toggle we have two button, buttonName1 is the name of first button
  // buttonName2 (String) = In toggle we have two button, buttonName2 is the name of second button
  // handleChange (fn) => to have the activity of toggle button

export default function PackageToogleButton({ type = "monthly", buttonName1 = ct("rta-trmc.dashboard.subscription.monthly"), buttonName2 = ct("rta-trmc.dashboard.subscription.annual"), types = { type1: "monthly", type2: "yearly" }, handleChange, style = { wrapperBoxWidth: "200px", boxWidth: "100px" }, className = "mask" }) {
  return (
    <Box sx={{
      // width: style.wrapperBoxWidth,
      margin: "auto"
    }}>
      <Box className="mask-box">
        {/* <Box
          className={className}
          style={{
            transform: `translateX(${type === types.type1 ? 0 : style.boxWidth})`
          }}
        /> */}
        <Button
          id="toggle-btn-first"
          className={type === types.type1 ? "active" : ""}
          disableRipple
          variant="text"
          sx={{ color: type === types.type1 ? "#ffffff" : "#000" }}
          onClick={() => handleChange(types.type1)}
        >
          {buttonName1}
        </Button>
        <Button
          id="toggle-btn-second"
          className={type === types.type2 ? "active" : ""}
          disableRipple
          variant="text"
          sx={{ color: type === types.type2 ? "#ffffff" : "#000" }}
          onClick={() => handleChange(types.type2)}
        >
          {buttonName2}
        </Button>
      </Box>
    </Box>
  );
}
